import React from 'react';
import { CalendarCheckIcon, PhoneCallIcon, PlugZapIcon } from 'lucide-react';
import { steps } from '../data/content';
import { Reveal } from './showcase/Reveal';
import { CallVignette } from './showcase/CallVignette';
const icons = {
  plug: PlugZapIcon,
  phone: PhoneCallIcon,
  calendar: CalendarCheckIcon
};
export function HowItWorks() {
  return <section id="steps" aria-labelledby="steps-title" className="scroll-mt-20 border-b border-white/5 bg-ink-800" data-id="element-128" data-mp="3u264rq1b5ap2">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-129" data-mp="qjwdf657pweq">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-130" data-mp="ql7jxdq1li9j">
          The three steps
        </p>
        <h2 id="steps-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-131" data-mp="gt1otv4hukq4">
          Connect, answer, book. Nothing your agents have to learn.
        </h2>

        <ol className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-132" data-mp="19b5o3iqpyr7w">
          {steps.map(step => {
          const Icon = icons[step.icon];
          return <li key={step.number} className="rounded-xl border border-white/10 bg-ink-700 p-7" data-id="element-133" data-mp="2mncp75hs6ih8">
                <div className="flex items-center justify-between" data-id="element-134" data-mp="31dk8fnfm45iz">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-brand/30 bg-brand/10" data-id="element-135" data-mp="2wjz8hpugl1h5">
                    <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-136" data-mp="3ae8o0mknmdxz" />
                  </span>
                  <span className="font-display text-sm font-semibold tracking-widest text-white/25" data-id="element-137" data-mp="36cn4iidm71et">
                    {step.number}
                  </span>
                </div>
                <h3 className="mt-6 font-display text-xl font-semibold tracking-tight text-white" data-id="element-138" data-mp="3fbs0bgxskgna">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-139" data-mp="1kxhezigeo4m9">{step.body}</p>
              </li>;
        })}
        </ol>

        <div className="mt-14 grid gap-8 lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-140" data-mp="3l11pmx1hoys3">
          <Reveal delay={0.05} data-id="element-141" data-mp="3pzlg9ar12yqs">
            <CallVignette data-id="element-142" data-mp="3q0o3n8p56j1y" />
          </Reveal>
          <Reveal delay={0.12} data-id="element-143" data-mp="3tzvutbsvyxh9">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-brand" data-id="element-144" data-mp="3tyluefyk9d7g">
              Step 02 in action
            </p>
            <h3 className="mt-4 max-w-md font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-145" data-mp="7syo9gkwhdfm">
              Answer and qualify, live on the first call.
            </h3>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-white/60 sm:text-base" data-id="element-146" data-mp="hiqjmd0tqal5">
              This is an after-hours portal call being picked up, worked on your script,
              and qualified down to price range, pre-approval, and tour timing before your
              agents ever see it. Demo data shown.
            </p>
          </Reveal>
        </div>

        <p className="mt-14 max-w-3xl text-sm leading-relaxed text-white/55" data-id="element-147" data-mp="vit2a1gyh81g">
          Book and log also covers the paperwork: a booked tour triggers your
          brokerage&rsquo;s buyer touring agreement for e-signature, with reminders until
          it is signed before the showing.
        </p>
        <p className="mt-4 max-w-2xl text-sm text-white/50" data-id="element-148" data-mp="vqd2m564d2r7">
          Every appointment we book is speed to lead you are already paying for. More
          buyer consults, more listing appointments, more GCI on the board.
        </p>
      </div>
    </section>;
}